import { Component } from '@angular/core';

import { OddsCardResult } from '../../common/odds-card-result/odds-card-result';

@Component({
    selector: 'odds-card-result-component',
    templateUrl: 'odds-card-result.component.html',
    styleUrls: ['odds-card-result.component.scss'],
    standalone: true,
})
export class OddsCardResultComponent extends OddsCardResult {}
